import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfigRow } from './config-table.component';

export interface ConfigDeactivateDialogData {
  row: ConfigRow;
  deactivateFn: (id: number) => Observable<void>;
}

@Component({
  selector: 'app-config-deactivate-dialog',
  templateUrl: './config-deactivate-dialog.component.html',
  styles: [`
    .deactivate-error {
      color: #c62828;
      font-size: 14px;
      padding: 8px 0 0;
    }
    .system-default-warn {
      color: #e65100;
      font-size: 14px;
      margin: 8px 0 4px;
    }
    .confirm-input { width: 100%; margin-top: 8px; }
  `],
})
export class ConfigDeactivateDialogComponent {
  errorMessage = '';
  deactivating = false;
  confirmInput = '';

  constructor(
    public dialogRef: MatDialogRef<ConfigDeactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfigDeactivateDialogData,
  ) {
    dialogRef.disableClose = true;
  }

  get isSystemDefault(): boolean {
    return !!this.data.row['isSystemDefault'];
  }

  get confirmReady(): boolean {
    return !this.isSystemDefault || this.confirmInput.trim().toUpperCase() === 'CONFIRM';
  }

  confirm(): void {
    if (!this.confirmReady) return;
    this.deactivating = true;
    this.errorMessage = '';
    this.data.deactivateFn(this.data.row.id).subscribe({
      next: () => this.dialogRef.close(true),
      error: (e: any) => {
        this.deactivating = false;
        this.errorMessage =
          e?.status === 409
            ? (e?.error?.message ??
              'Cannot deactivate — this item is used by existing records. Remove those references first.')
            : (e?.error?.message ?? 'Deactivate failed. Please try again.');
      },
    });
  }

  cancel(): void {
    if (this.deactivating) return;
    this.dialogRef.close(false);
  }
}
